import { render, staticRenderFns } from "./html-text-widget.vue?vue&type=template&id=5b64c2ea&scoped=true&"
import script from "./html-text-widget.vue?vue&type=script&lang=js&"
export * from "./html-text-widget.vue?vue&type=script&lang=js&"
import style0 from "./html-text-widget.vue?vue&type=style&index=0&id=5b64c2ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b64c2ea",
  null
  
)

export default component.exports